module.exports = __webpack_public_path__ + "img/get-a-life-chloe-brown.183bd453.png";